import React from "react";
import Routes from "./Routes";

function App() {
  return (
    <>
      {/* Global backdrop applied across all routes */}
      {/* Keep backdrop above the root background paint, but below all app content */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        {/* Light-mode tint layers to keep text readable while letting the background image show through */}
        <div className="absolute inset-0 bg-gradient-to-b from-background/95 via-background/70 to-background/90" />
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-95"
          style={{ backgroundImage: "url('/assets/images/Neevi_landing_page_light_background.png')" }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-secondary/10 via-transparent to-accent/10" />
      </div>

      <div className="relative z-10">
      <Routes />
      </div>
    </>
  );
}

export default App;
